import { AppUtil } from 'kuaidong-lib'
import {
  Clazz,
  IPaperDetail,
  IStudentPrize,
  IChallengeRepoItem,
  IClazzStaticSummary,
  ITrainingListItem,
  IWinter2023Config,
  IWinter2023LessonsQurey,
  IWinter2023Form,
  ISAutumn2022Homework,
  ISAutumn2022ListItem,
  IWinter2023Preview,
  ChallengeConfig,
  IStatusOfWinter2023Awards,
  IStudentStaticSummary,
  IStudentChallengeRecord,
  ICreateExamOrChallengeForm,
  IPaperItem,
  ITeacherPaperExamItem,
  IPaperExamStaticInfo,
  IExamStudentStaticInfo,
  IExamStudentPaper,
  IWinter2023Stat,
  ITeacherPaperExamItemUpdate,
  IYearTopRank,
  IYearTopRankMine,
  IWinter2023UserContribution,
  IWinter2023UserContributionMine,
  IWinter2023UserContributionForm,
  IWinter2023MixSubjectsItem,
  IWinter2023MixSubjectClazzSummary,
  IWinter2023MixSubjectClazzItem,
  IWinter2023MixSubjectStudentItem,
} from 'kuaidong-model'

export class AWinter2023 {
  static achieveConfig(): Promise<IWinter2023Config[]> {
    return AppUtil.httpGET('/activity/winter_2022/config')
  }

  static achieveClasses(): Promise<Clazz[]> {
    return AppUtil.httpGET('/activity/winter_2022/classes')
  }

  static detailOfSafeLessons(
    query: Pick<IWinter2023LessonsQurey, 'task_id' | 'option_id'>
  ): Promise<{ course_id: string }> {
    return AppUtil.httpPOST('/activity/winter_2022/preview/online_course', { ...query })
  }

  static detailOfPELessons(query: IWinter2023LessonsQurey): Promise<ISAutumn2022Homework[]> {
    return AppUtil.httpPOST('/activity/winter_2022/preview/homework', { ...query })
  }

  static detailOfQAOrSkills(
    query: Omit<IWinter2023LessonsQurey, 'start_date' | 'end_date'>
  ): Promise<{ challenge_id: string }> {
    return AppUtil.httpPOST('/activity/winter_2022/preview/challenge', { ...query })
  }

  static create(form: IWinter2023Form): Promise<{ id: string }> {
    return AppUtil.httpPOST('/activity/winter_2022/create', { ...form })
  }

  static list(): Promise<ISAutumn2022ListItem[]> {
    return AppUtil.httpGET('/activity/winter_2022/list')
  }

  static delete(vacation_plan_id: string) {
    return AppUtil.httpDelete('/activity/winter_2022/delete', { vacation_plan_id })
  }

  static preview(vacation_plan_id: string): Promise<IWinter2023Preview> {
    return AppUtil.httpGET('/activity/winter_2022/detail', { vacation_plan_id })
  }

  static async paperDetail(paper_id: string): Promise<IPaperDetail> {
    return AppUtil.httpGET('/web/paper/paper_detail', { paper_id })
  }

  static challengeItems(challenge_id: string): Promise<ChallengeConfig> {
    return AppUtil.httpGET('/web/challenge/challenge_items', { challenge_id }).then((res) => ({
      ...res,
      challenge_id,
    }))
  }

  static challengePrizes(challengeId: string): Promise<IStudentPrize[]> {
    return AppUtil.httpGET('/web/challenge/challenge_award_list', { challenge_id: challengeId })
  }

  static challengeOrTrainingList(
    challenge_type: 'KNOWLEDGE' | 'SPECIAL_EXERCISE',
    isUniversity = false
  ): Promise<ITrainingListItem[]> {
    if (isUniversity) {
      return AppUtil.httpGET('/web/challenge/teacher_grade_challenge', {
        challenge_type,
      })
    } else {
      return AppUtil.httpGET('/web/challenge/teacher_challenge', {
        challenge_type,
      })
    }
  }

  static challengeRepoList(challenge_type: 'KNOWLEDGE' | 'SPECIAL_EXERCISE'): Promise<IChallengeRepoItem[]> {
    return AppUtil.httpGET('/web/challenge/challenge_repo_list', {
      challenge_type,
    })
  }

  static paperList(): Promise<IPaperItem[]> {
    return AppUtil.httpGET('/web/paper/paper_list')
  }

  static trainingClassSummary(group_id: string, class_id: number | null = null): Promise<IClazzStaticSummary> {
    return AppUtil.httpGET('/web/challenge/statistic/class_summary', {
      group_id,
      class_id,
    })
  }

  static trainingClassSummaryList(group_id: string, class_id: number | null = null): Promise<IClazzStaticSummary[]> {
    return AppUtil.httpGET('/web/challenge/statistic/class_summary_list', {
      group_id,
      class_id,
    })
  }

  static classStudentList(challenge_class_id: string): Promise<IStudentStaticSummary[]> {
    return AppUtil.httpGET('/web/challenge/statistic/class_student_list', {
      challenge_class_id,
    })
  }

  static studentRecord(user_id: string, challenge_class_id: string): Promise<IStudentChallengeRecord> {
    return AppUtil.httpGET('/web/challenge/statistic/student_record', {
      user_id,
      challenge_class_id,
    })
  }

  static achieveStatusOfAwards(): Promise<IStatusOfWinter2023Awards> {
    return AppUtil.httpGET('/activity/winter_2022/reward/teacher/status')
  }

  static achieveCourse(course_id: string) {
    return AppUtil.httpPOST('/activity/winter_2022/reward/teacher/teacher_course', { course_id })
  }

  static achieveGift() {
    return AppUtil.httpPOST('/activity/winter_2022/reward/teacher/gift_pack')
  }

  static achieveCourses(): Promise<{ title: string; id: string }[]> {
    return AppUtil.httpGET('/activity/winter_2022/reward/teacher/teacher_course')
  }

  static achieveAwardsOfChallenge(vacation_plan_id: string): Promise<IStudentPrize[]> {
    return AppUtil.httpGET('/activity/winter_2022/reward/student', { vacation_plan_id })
  }

  static createExamOrChallenge(form: ICreateExamOrChallengeForm, isUniversity = false): Promise<any> {
    if (isUniversity) {
      return AppUtil.httpPOST('/web/paper/create_exam_or_challenge', { ...form, class_id_list: null })
    } else {
      return AppUtil.httpPOST('/web/paper/create_exam_or_challenge', { ...form, grade_ids: null })
    }
  }

  static teacherPaperExamList(isUniversity = false): Promise<ITeacherPaperExamItem[]> {
    if (isUniversity) {
      return AppUtil.httpGET('/web/paper/teacher_grade_paper_exam_list')
    } else {
      return AppUtil.httpGET('/web/paper/teacher_paper_exam_list')
    }
  }

  static examStatisticClazzSummary(exam_id: string): Promise<IPaperExamStaticInfo> {
    return AppUtil.httpGET('/web/exam/statistic/class_summary', {
      exam_id,
    })
  }

  static examStatisticStudentSummary(exam_id: string, class_id: number): Promise<IExamStudentStaticInfo> {
    return AppUtil.httpGET('/web/exam/statistic/student_summary', {
      exam_id,
      class_id,
    })
  }

  static examStatisticStudentPaper(online_exam_class_id: string, user_id: string): Promise<IExamStudentPaper> {
    return AppUtil.httpGET('/web/exam/statistic/student_paper', {
      online_exam_class_id,
      user_id,
    })
  }

  static stat(query: { type: string; value: any }): Promise<IWinter2023Stat> {
    return AppUtil.httpPOST('/activity/winter_2022/stat', { ...query })
  }

  static deleteTeacherChallenge(group_id: string) {
    return AppUtil.httpDelete('/web/challenge/teacher_challenge', {
      group_id,
    })
  }

  static createTeacherChallenge(form: any) {
    return AppUtil.httpPOST('/web/challenge/teacher_challenge', form)
  }

  static updateTeacherChallenge(form: ITrainingListItem) {
    return AppUtil.httpPUT('/web/challenge/teacher_challenge', form)
  }

  static deleteTeacherPaperExam(online_exam_id: string) {
    return AppUtil.httpDelete('/web/paper/teacher_paper_exam_list', {
      online_exam_id,
    })
  }

  static updatePaperExam(form: ITeacherPaperExamItemUpdate) {
    return AppUtil.httpPUT('/web/paper/teacher_paper_exam_list', form)
  }

  static exportExam(exam_id: string) {
    return AppUtil.httpGET('/web/exam/statistic/export', {
      exam_id,
    })
  }

  static exportPractice(group_id: string) {
    return AppUtil.httpGET('/web/challenge/statistic/export', {
      group_id,
    })
  }

  static onlineExamRemind(online_exam_id?: string) {
    return AppUtil.httpPUT('/web/exam/online_exam_remind', {
      online_exam_id,
    })
  }

  static yearTopRank(): Promise<IYearTopRank[]> {
    return AppUtil.httpGET('/activity/year_top/year_top_rank')
  }

  static yearTopRankMine(): Promise<IYearTopRankMine> {
    return AppUtil.httpGET('/activity/year_top/year_top_rank_mine')
  }

  static userContribution(form: IWinter2023UserContributionForm) {
    return AppUtil.httpPOST('/activity/year_top/user_contribution', form)
  }

  static userContributionRank(): Promise<IWinter2023UserContribution[]> {
    return AppUtil.httpGET('/activity/year_top/user_contribution_rank')
  }

  static userContributionRankMine(): Promise<IWinter2023UserContributionMine> {
    return AppUtil.httpGET('/activity/year_top/user_contribution_rank_mine')
  }

  static mixSubjectsList(activity_id: string): Promise<IWinter2023MixSubjectsItem[]> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/list', { activity_id })
  }

  static mixSubjectsOverInfo(
    activity_id: string,
    inter_subject_practice_id: string
  ): Promise<IWinter2023MixSubjectsItem> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/detail', {
      activity_id,
      inter_subject_practice_id,
    })
  }

  static mixSubjectsClassSummary(
    activity_id: string,
    inter_subject_practice_id: string
  ): Promise<IWinter2023MixSubjectClazzSummary> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/stat/summary', {
      activity_id,
      inter_subject_practice_id,
    })
  }

  static mixSubjectsClassList(
    activity_id: string,
    inter_subject_practice_id: string
  ): Promise<IWinter2023MixSubjectClazzItem[]> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/stat/classes', {
      activity_id,
      inter_subject_practice_id,
    })
  }

  static mixSubjectsStudentSummary(
    activity_id: string,
    inter_subject_practice_id: string,
    class_id: number
  ): Promise<IWinter2023MixSubjectClazzSummary> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/stat/summary/class', {
      activity_id,
      inter_subject_practice_id,
      class_id,
    })
  }

  static mixSubjectsStudentList(
    activity_id: string,
    inter_subject_practice_id: string,
    class_id: number
  ): Promise<IWinter2023MixSubjectStudentItem[]> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/stat/students', {
      activity_id,
      inter_subject_practice_id,
      class_id,
    })
  }

  static mixSubjectsDownload(activity_id: string, inter_subject_practice_id: string): Promise<string> {
    return AppUtil.httpGET('/activity/general/inter_subject_practice/stat/export', {
      activity_id,
      inter_subject_practice_id,
    })
  }
}
